// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from "jquery";

const fragments = {
	INPUTS: '.form-group--float-label input',
	TEXTAREAS: '.form-group--float-label textarea',
	DISABLED: '*[disabled]',
	SELECTS: '.form-group--float-label select',
	REQUIRED: '*[required], *[data-required]',
};

export default class Form extends WebComponent {
	constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	didMount() {
		const {
			preventMultipleSubmit,      // zabrana proti vicenasobnemu odeslani formulare
			submitOnChange,             // provede submit v pripade vyvolani change eventy na komponentach formulare
			turbolinksForm,           // odeslani formulare ajax requestem
		} = this.props;

		if (preventMultipleSubmit !== false || turbolinksForm === true) {
			this.on('submit', this.handleSubmit);
		}
		if (submitOnChange === true) {
			this.inputElements = this.element.querySelectorAll('input:not([type="submit"])');
			this.handleSubmitOnChange();
		}

		this.iterLabels(this.element);

		/**
		 * scroll to failed validation element
		 **/
		this.handleValidationFailed();

		$(document).on('afterContentsReplaced', () => {
			if(this.element) {
				this.iterLabels(this.element);
			}
		});
	}

	handleValidationFailed = () => {
		let hasErrorEl = document.querySelectorAll('.has-error');
		if (hasErrorEl.length > 0 && !this.isElementInViewport(hasErrorEl[0])) {
			if(hasErrorEl[0] && hasErrorEl[0].getBoundingClientRect()){
				window.scrollTo(0, hasErrorEl[0].getBoundingClientRect().top + window.scrollY - 100);
			}
		}
	}

	iterLabels = (el) => {
		let _self = this;
		this.inputsElement = el.querySelectorAll(fragments.INPUTS);
		this.textareasElement = el.querySelectorAll(fragments.TEXTAREAS);
		this.disabledElement = el.querySelectorAll(fragments.DISABLED);
		this.requiredElement = el.querySelectorAll(fragments.REQUIRED);
		this.selectsElement = el.querySelectorAll(fragments.SELECTS);

		/**
		 * set timeout to make sure esp target content is found and form elements can be reinitiated
		 */
		setTimeout(function(){
			for (let i = 0; i < _self.inputsElement.length; i++) {
				if(!_self.inputsElement[i].parentElement.classList.contains('ss-search')){
					_self.initLabels(_self.inputsElement[i]);
					_self.inputsElement[i].addEventListener('focus', _self.focusHandler);
					_self.inputsElement[i].addEventListener('blur', _self.blurHandler);
					_self.inputsElement[i].addEventListener('input', _self.focusHandler);
				}
			}

			for (let i = 0; i < _self.textareasElement.length; i++) {
				_self.initLabels(_self.textareasElement[i]);
				_self.textareasElement[i].addEventListener('focus', _self.focusHandler);
				_self.textareasElement[i].addEventListener('blur', _self.blurHandler);
			}

			for (let i = 0; i < _self.selectsElement.length; i++) {
				_self.initLabels(_self.selectsElement[i]);
				_self.selectsElement[i].addEventListener('focus', _self.focusHandler);
				_self.selectsElement[i].addEventListener('blur', _self.blurHandler);
			}

			for (let i = 0; i < _self.disabledElement.length; i++) {
				_self.initLabels(_self.disabledElement[i]);
			}
		},200);
	}

	initLabels = (element) => {
		let fG = element.closest('.form-group');
		if (fG) {
			if ((element.value === "" && !element.disabled) && element.tagName !== 'SELECT') {
				fG.classList.remove('form-group--label-active');
			} else {
				fG.classList.add('form-group--label-active');
			}
		}
	};

	focusHandler = (e) => {
		let fG = e.target.closest('.form-group');
		if (fG) {
			fG.classList.add('form-group--label-active');
		}
	};

	blurHandler = (e) => {
		let fG = e.target.closest('.form-group');
		if (fG) {
			if (e.target.value === "" && e.target.tagName !== 'SELECT') {
				fG.classList.remove('form-group--label-active');
			}
		}
	};

	isElementInViewport = (el) => {
		let top = el.offsetTop;
		let left = el.offsetLeft;
		const width = el.offsetWidth;
		const height = el.offsetHeight;

		while (el.offsetParent) {
			el = el.offsetParent;
			top += el.offsetTop;
			left += el.offsetLeft;
		}

		return (
				top < (window.pageYOffset + (window.innerHeight * Form.defaultProps.viewportPercentage)) &&
				left < (window.pageXOffset + window.innerWidth) &&
				(top + height) > window.pageYOffset &&
				(left + width) > window.pageXOffset
		);
	};


	willUnMount() {
		const {
			submitOnChange,
		} = this.props;

		if (submitOnChange === true && this.inputElements) {
			this.inputElements.forEach((inputElement) => {
				inputElement.removeEventListener('change', this.handleChange);
			});
		}
		this.inputElements = null;
	}

	/*
	  Zamezeni pred vicenasobnym odeslanim formulare
	 */
	handleSubmit() {
		const {
			preventMultipleSubmit,      // zabrana proti vicenasobnemu odeslani formulare
			turbolinksForm,           // odeslani formulare ajax requestem
		} = this.props;

		const submitElements = this.element.querySelectorAll('[type="submit"]');

		if (preventMultipleSubmit !== false) {
			setTimeout(() => {
				if (submitElements) {
					submitElements.forEach((submitElement) => {
						submitElement.setAttribute('disabled', 'disabled');
					});
				}
			}, 1)
		}


	}

	/*
	  Submit formulare pri zmene
	 */
	handleChange() {
		this.element.submit();
	}

	/*
	  Osetreni submitu formulare pri zmene inputu
	 */
	handleSubmitOnChange() {
		if (this.inputElements) {
			this.inputElements.forEach((inputElement) => {
				inputElement.addEventListener('change', this.handleChange);
			});
		}
	}
}

Form.defaultProps = {
	viewportPercentage: 1,
};




// WEBPACK FOOTER //
// ./fe/web-bn/src/js/components/Form.js